import { ArrowLeftIcon, ArrowRightIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import { DsmColor } from '../../../constants/colors.mjs';
import { factory } from '../../../factory/factory.utils.mjs';
import { Typography } from '../../../Foundations/Typography/Typography.mjs';
import { Box } from '../../../Other/Box/Box.mjs';
import classes from './CalendarHeader.module.css.mjs';

const CalendarHeader = factory((props, ref) => {
  const {
    className,
    onNext,
    onPrevious,
    onLevelClick,
    label,
    nextLabel = "next",
    previousLabel = "previous",
    nextDisabled = false,
    previousDisabled = false,
    hasNextLevel = true,
    levelControlAriaLabel,
    withNext = true,
    withPrevious = true,
    __preventFocus,
    __stopPropagation,
    ...rest
  } = props;
  const preventFocus = __preventFocus ? (event) => event.preventDefault() : void 0;
  return /* @__PURE__ */ React.createElement(Box, { className: clsx(className, classes.calendarHeader), ref, ...rest }, /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "label-regular-l",
      className: classes.calendarHeaderLabel,
      component: hasNextLevel ? "button" : "div",
      textColor: DsmColor.ContentSecondary,
      onClick: hasNextLevel ? onLevelClick : void 0,
      onMouseDown: hasNextLevel ? preventFocus : void 0,
      disabled: !hasNextLevel,
      "data-static": !hasNextLevel || void 0,
      "aria-live": "polite",
      "aria-label": levelControlAriaLabel,
      tabIndex: __preventFocus || !hasNextLevel ? -1 : 0,
      "data-kohler-stop-propagation": __stopPropagation || void 0
    },
    label
  ), /* @__PURE__ */ React.createElement(Box, { className: classes.calendarHeaderControlsWrapper }, withPrevious && /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      "data-direction": "previous",
      "aria-label": previousLabel,
      onClick: onPrevious,
      onMouseDown: preventFocus,
      disabled: previousDisabled,
      "data-disabled": previousDisabled || void 0,
      tabIndex: __preventFocus || previousDisabled ? -1 : 0,
      "data-kohler-stop-propagation": __stopPropagation || void 0,
      textColor: previousDisabled ? "var(--content-action-inactive)" : "var(--content-secondary)"
    },
    /* @__PURE__ */ React.createElement(ArrowLeftIcon, { "data-direction": "previous", size: "small", withBoundingBox: false })
  ), withNext && /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      "data-direction": "next",
      "aria-label": nextLabel,
      onClick: onNext,
      onMouseDown: preventFocus,
      disabled: nextDisabled,
      "data-disabled": nextDisabled || void 0,
      tabIndex: __preventFocus || nextDisabled ? -1 : 0,
      "data-kohler-stop-propagation": __stopPropagation || void 0,
      textColor: nextDisabled ? "var(--content-action-inactive)" : "var(--content-secondary)"
    },
    /* @__PURE__ */ React.createElement(ArrowRightIcon, { size: "small", withBoundingBox: false, "data-direction": "next" })
  )));
});

export { CalendarHeader };
